import { useFieldHelper, LinkField } from 'framework/ui/field';
import LinkIcon from '@mui/icons-material/Link';
import { Stack, Box } from '@mui/material';
import { getAnchor } from 'framework/utils';
import { Milestone } from 'domain/shared/newProject';
import { BusinessOutcomesType } from './types';

type LinkedMilestonesFieldProps = {
  source: string;
  options?: Milestone[] | BusinessOutcomesType[];
  isCompletedFn?: (option?: Milestone | BusinessOutcomesType) => boolean;
};

const LinkedMilestonesField = ({ source, options = [], isCompletedFn }: LinkedMilestonesFieldProps) => {
  const { getValue } = useFieldHelper<string[]>({ source });
  const aliases = getValue();

  const renderItems = () =>
    aliases.map((alias, index) => {
      const matchedOption = options.find(opt => opt.alias === alias);
      const isCompleted = isCompletedFn?.(matchedOption);

      return (
        <Box component="span" key={alias}>
          {index > 0 && ', '}

          <Box
            component="span"
            sx={{
              textDecoration: isCompleted ? 'line-through' : 'none',
              opacity: isCompleted ? 0.65 : 1,
            }}
          >
            <LinkField linkText={matchedOption?.alias || alias} isInternal value={`#${getAnchor(alias)}`} />
          </Box>
        </Box>
      );
    });

  return (
    <Stack direction="row" spacing={1}>
      <LinkIcon
        sx={{
          transform: 'rotate(-45deg)',
          fontSize: '1.2rem',
          color: 'text.secondary',
        }}
      />
      <Box component="span">{aliases?.length > 0 ? renderItems() : <>-</>}</Box>
    </Stack>
  );
};

export default LinkedMilestonesField;
